import { useState } from 'react'
import { Checkbox } from '@wiggot/web-components'
import { CustomDropdown } from './CustomDropdown'

interface IOption {
  [key: string]: string
}

interface IDropdown {
  filter: string[]
  setFilters: (o: any) => void
  options: IOption[]
  isLoading?: boolean
  name: string
  placeholder: string
  onClose: (cb: () => void) => void
  onConfirm: (cb: () => void) => void
  idBase: string
  isRadio?: boolean
  pillButtonClassName?: string
  pillButtonContainerClassName?: string
}

export interface ICommonOptionObject {
  label: string
  value?: string | number | null
}

export const Dropdown = ({
  filter,
  setFilters,
  options,
  isLoading = false,
  name,
  placeholder,
  onClose,
  onConfirm,
  idBase,
  isRadio = false,
  pillButtonClassName,
  pillButtonContainerClassName
}: IDropdown) => {
  const [isOpen, setIsOpen] = useState(false)

  const onClearFilters = () => {
    setFilters((prev: any) => ({ ...prev, [name]: [] }))
    setIsOpen(false)
  }

  const handleOnClose = () => {
    setIsOpen(false)
  }

  const renderOptions = () => {
    const selectOptions: ICommonOptionObject[] = options?.map(
      (op: IOption) => ({
        label: op.label,
        value: op.value
      })
    )

    return selectOptions?.map(({ label = '', value = '' }) => (
      <Checkbox
        key={`${idBase}-${label}`}
        name={isRadio ? (label || '')?.toString() : `${idBase}-${label}`}
        id={isRadio ? (label || '')?.toString() : `${idBase}-${label}`}
        onChange={(val) => {
          if (isRadio) {
            handleOnClose()
            return setFilters(value)
          }
          const newArr = filter
          if (val && typeof value === 'string') {
            newArr?.push(value)
            setFilters((prev: any) => ({ ...prev, [name]: newArr }))
          } else if (typeof value === 'string') {
            newArr?.splice(newArr?.indexOf(value), 1)
            setFilters((prev: any) => ({ ...prev, [name]: newArr }))
          }
        }}
        type={isRadio ? 'radio' : 'checkbox'}
        items="start"
        containerClassName="bg-white h-full py-1"
        label={label}
        labelClassName="text-primary"
        isChecked={
          (typeof value === 'string' && filter?.includes(value)) || false
        }
      />
    ))
  }

  return (
    <CustomDropdown
      isOpen={isOpen && !isLoading}
      setIsOpen={isLoading ? () => null : setIsOpen}
      placeholder={placeholder}
      menuTitle={placeholder}
      renderOptions={renderOptions()}
      onReset={onClearFilters}
      withSearch={false}
      searchVal=""
      setSearchVal={() => null}
      activeFilters={filter?.length}
      onConfirm={() => onConfirm(handleOnClose)}
      onClose={() => onClose(handleOnClose)}
      withoutFooter={isRadio}
      pillButtonClassName={pillButtonClassName}
      pillButtonContainerClassName={pillButtonContainerClassName}
    />
  )
}
